<template>
  <el-col :span="12">
    <el-row class="title-bar" type="flex" justify="space-between" align="middle">
      <div class="vertical-center-box">
        <div class="title-h4 mr-r10">DB 설정</div>
        <el-button icon="fas fa-cog" @click="onClickDbSetting"></el-button>
      </div>
      <el-switch v-model="formData.dbSettingFlag" @change="onDbSettingFlagChange"></el-switch>
    </el-row>
    <el-form v-show="formData.dbSettingFlag" ref="dbSettingForm" :model="formData" :rules="rules">
      <el-row>
        <el-form-item label="DB접속명" prop="dbSettingId">
          <el-select size="small" style="width: 100%" v-model="formData.dbSettingId">
            <el-option v-for="item in dbList" :key="item.dbSettingId" :label="item.dbSettingName" :value="item.dbSettingId"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="SQL">
          <el-input type="textarea" v-model="formData.dbSql" rows="10"></el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <w-e2e-db-setting-sliding-popup :service-info="serviceInfo" :db-list="this.dbList" ref="dbSettingSliding" @load-data="loadData"></w-e2e-db-setting-sliding-popup>
  </el-col>
</template>

<script>
import DeviceRegistrationE2eApi from '@/api/settings/common/device-registration-e2e';
import WE2eDbSettingSlidingPopup from '../popup/E2eDbSettingSlidingPopup';

export default {
  name: 'WE2eDbSettingForm',
  components: {
    WE2eDbSettingSlidingPopup,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    serviceInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dbList: null,
      rules: {
        dbSettingId: {
          required: true,
          trigger: 'blur',
          message: 'DB접속명을 선택해주십시오.',
        },
      },
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    formData: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    loadData(targetDbSettingId) {
      this.dbList = [];
      DeviceRegistrationE2eApi.getDbList().then((response) => {
        this.$nextTick(() => {
          if (targetDbSettingId && this.formData.dbSettingId === targetDbSettingId) {
            this.formData.dbSettingId = null;
            this.formData.dbSql = null;
          }
          this.dbList = response.data.data;
        });
      });
    },
    onClickDbSetting() {
      this.$refs.dbSettingSliding.open();
    },
    onDbSettingFlagChange() {
      this.$refs.dbSettingForm.clearValidate();
    },
    getForm() {
      return this.$refs.dbSettingForm;
    },
  },
};
</script>

<style scoped>
.regist-wizard-form-title {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/E2eDevice/components/E2eDbSettingForm.vue